<template>
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Financiamiento</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <label for="nombre">Nombre</label>
            <input v-model="nombre" class="form-control" type="text" id="nombre" placeholder="Nombre">
            <br>
            <label for="apellido">Apellido</label>
            <input v-model="apellidos" class="form-control" type="text" id="apellido" placeholder="Apellido">
            <br>
            <label for="email">Correo electrónico</label>
            <input v-model="email" class="form-control" type="email" id="email" placeholder="Correo electrónico">
            <br>
            <label for="telefono">Teléfono</label>
            <input v-model="telefono" class="form-control" type="number" id="telefono" placeholder="Teléfono">
            <br>
            <label for="mensaje">Mensaje</label>
            <textarea v-model="mensaje" class="form-control" name="mensjae" id="mensaje" placeholder="Mensaje" cols="30" rows="10"></textarea>
            <br>
            <a style="margin-right: 1em" target="_blank" >¿Desea llenar solicitud de crédito?</a>
            <a style="margin-right: 1em" @click="solcre" href="/solicitud-credito" target="_blank">Sí</a>
            <a @click="solcre" href="#">No</a>
            <br>
            <label v-if="dontShow" for="solicitud">Solicitud</label>
            <input v-if="dontShow" @change="previewFiles" type="file" id="solicitud" class="form-control">
            <br>
            <div v-show="end" class="alert alert-success" role="alert">
              Solicitud enviada
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button id="ternar" type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          <button @click="saveData" type="button" class="btn btn-primary">Elegir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
export default {
  name: 'ModalFinanciamiento',
  data () {
    return {
      nombre: '',
      apellidos: '',
      telefono: '',
      email: '',
      mensaje: '',
      solicitud: {},
      dontShow: false,
      end: false
    }
  },
  methods: {
    previewFiles (evt) {
      console.log(evt.target)
      this.solicitud = evt.target.files[0]
    },
    solcre () {
      // this.dontShow = true
      this.dontShow = !this.dontShow
      console.log('credito')
    },
    saveData () {
      console.log('salvandoi')
      this.$http.post('/web/contact/', {
        nombre: this.nombre,
        apellidos: this.apellidos,
        telefono: this.telefono,
        email: this.email,
        mensaje: this.mensaje
      }, {
        headers: {
          'Content-Type': 'application/josn'
        }
      }).then(res => {
        console.log('datos')
        console.log(res)
      })

      if (this.dontShow) {
        const fd = new FormData()
        fd.append('solicitud', this.solicitud)
        fd.append('email', this.email)
        this.$http.post('/web/contact/solicitud', fd, {
          headers: {
            'Content-Type': 'application/josn'
          }
        }).then(res => {
          console.log('solicitud')
          console.log(res)
        })
      }
      this.end = true
    }
  }
}
</script>

<style scoped>

</style>
